// extracted by mini-css-extract-plugin
module.exports = {"btn":"IconButton_btn__3N2u3","danger":"IconButton_danger__1gWHL","ghost":"IconButton_ghost__3hQjv"};